import { BASE_URL } from "../utils/BaseUrl";
import httpRequest from "../utils/httpsRequest";

export const Customers = async (payload) => {
    return await httpRequest(`${BASE_URL}/Customers/${payload}`, "get" );
  }